"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var Types = require("types");
var modalActions = require("@caddigital/sok-reducers/lib/actions/sokosite/configModal");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var ColumnFilter_1 = require("components/ColumnFilter");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var headers = ['id', 'name', 'ownership', 'description'];
var mapStateToProps = function (state) {
    return {
        modal: state.sokosite.configModal,
        orderByOptions: state.sokosite.configModal.orderByOptions,
        filterOptions: state.sokosite.configModal.filterOptions,
        searchString: state.sokosite.configModal.searchString
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    setOrderBy: function (orderBy, order) {
        return dispatch(modalActions.setOrderBy(orderBy, order));
    },
    setColumnFilter: function (field, value) {
        return dispatch(modalActions.setColumnFilter(field, value));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var getFilteredData = function (list, searchString, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (searchString.length > 0) {
            return list.filter(function (item) {
                return item.id && item.id.toString().includes(searchString.toLowerCase());
            });
        }
        return list;
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var searchValue = filters[key];
            var value = item[key];
            if ((searchValue &&
                value !== undefined &&
                value.toString().toLowerCase().indexOf(searchValue.toLowerCase()) ===
                    -1) ||
                (searchValue && value === undefined)) {
                return result;
            }
            if (item.name.toString().includes(searchString)) {
                result.push(item);
            }
        }
        return result;
    }, []);
    return filtered;
};
var createHeader = function (props, identifier) {
    var order = props.modal.orderByOptions.order === 'asc' ? 'desc' : 'asc';
    return (React.createElement(sok_ui_1.Table.Column, { key: identifier, className: "".concat(identifier, "-column") },
        React.createElement("div", { className: "header-column-content" },
            React.createElement("div", { className: "header-column-text" }, (0, translation_1.getLocalization)("sokosite/configModal/".concat(identifier))),
            React.createElement(sok_ui_1.Table.SortButton, { onChange: function () { return props.setOrderBy(identifier, order); } }),
            React.createElement(ColumnFilter_1.ColumnFilter, { columnIdentifier: identifier, textInputValue: props.modal.filterOptions && props.modal.filterOptions[identifier]
                    ? props.modal.filterOptions[identifier] || ''
                    : '', inputType: 'text', setColumnFilterString: function (field, value) {
                    props.setColumnFilter(field, value);
                }, clearColumnFilter: function (field) {
                    props.setColumnFilter(field, undefined);
                } }))));
};
var createRow = function (row, props) {
    var disableCheckButton;
    if (props.activatedForms) {
        disableCheckButton = props.activatedForms.some(function (form) { return form.uuid === row.uuid; });
    }
    return (React.createElement(sok_ui_1.Table.Row, { key: row.uuid, className: "sokosite-modal-list-row" },
        React.createElement(sok_ui_1.Table.Column, null, !disableCheckButton && (React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', className: props.selected &&
                props.selected.find(function (form) { return form.uuid === row.uuid; })
                ? 'selected'
                : '', onClick: function (e) {
                e.stopPropagation();
                props.selected.includes(row)
                    ? props.setSelected(__spreadArray([], props.selected, true).filter(function (form) { return form.uuid !== row.uuid; }))
                    : props.setSelected(__spreadArray(__spreadArray([], props.selected, true), [row], false));
            } }))),
        React.createElement(sok_ui_1.Table.Column, null, row.id),
        React.createElement(sok_ui_1.Table.Column, null, row.name),
        React.createElement(sok_ui_1.Table.Column, null, row.ownership),
        React.createElement(sok_ui_1.Table.Column, null, row.description)));
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('items', 'setItems', []), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.setItems(this.props.formList);
    },
    componentDidUpdate: function (prevProps) {
        if (prevProps.formList !== this.props.formList) {
            this.props.setItems(this.props.formList);
        }
        if (prevProps.orderByOptions !== this.props.orderByOptions ||
            prevProps.searchString !== this.props.searchString ||
            prevProps.filterOptions !== this.props.filterOptions) {
            var orderBy_1 = this.props.orderByOptions.orderBy;
            var order_1 = this.props.orderByOptions.order === 'asc' ? 1 : -1;
            var list = this.props.formList;
            var filteredAndSorted = getFilteredData(list, this.props.searchString, this.props.filterOptions).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'id':
                        return a.id && b.id ? (a.id < b.id ? -1 : 1 * order_1) : 0;
                    case 'name':
                    case 'description':
                        return (a[orderBy_1] || '').localeCompare(b[orderBy_1] || '') * order_1;
                    case 'ownership':
                    default:
                        return 0;
                }
            });
            this.props.setItems(filteredAndSorted);
        }
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement("div", { className: "sokosite-modal-list" },
        React.createElement(sok_ui_1.Table.Table, { className: 'striped hovered' },
            React.createElement(sok_ui_1.Table.Head, { className: "sokosite-modal-list-header" },
                React.createElement(sok_ui_1.Table.Row, null,
                    React.createElement(sok_ui_1.Table.Column, null),
                    headers.map(function (header) { return createHeader(props, header); }),
                    React.createElement(sok_ui_1.Table.Column, null))),
            React.createElement(sok_ui_1.Table.Body, { className: "worksite-status-list-body" }, props.items.map(function (data) { return createRow(data, props); })))));
});
